import { useQuery } from '@tanstack/react-query';

import { endPoints as customerEndpoints } from 'src/app_deprecated/constants/CustomerConstants';

import { fetchData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

export const customerTypesEnabledForLspQueryKey: QueryKey = ['getCustomerTypesEnabledForLsp'];

type CustomerTypeProps = {
  CustomerType: string;
  CustomerTypeId: number;
};

export function useGetCustomerTypesEnabledForLspQuery() {
  return useQuery({
    queryKey: customerTypesEnabledForLspQueryKey,
    queryFn: () => fetchData<CustomerTypeProps[]>(customerEndpoints.GET_CUSTOMER_TYPES_ENABLED_FOR_LSP),
  });
}
